export const formMessages = {};

export const infoBubbleMessages = {
  parentPassword: `<p class="question"><strong>Qu'est-ce que le "mot de passe parent"?</strong></p>` +
  `<p>Il doit être différent du mot de passe famille.</p>` +
  `<p>Il vous permet d'accéder à votre compte en toute confidentialité.</p>` +
  `<p>Il vous permet également de modifier les informations relatives à votre compte et ses profils.</p>` +
  `<p>Il n'y a aucune contrainte pour le choix de ce mot de passe.</p>`,
  accountPassword: `<p class="question"><strong>Qu'est-ce que le "mot de passe famille"?</strong></p>` +
  `<p>Il vous permet d'accéder ainsi que votre/vos enfant(s) à vos profils afin de consulter chacun ` +
  ` de vos abonnements.</p>` +
  `<p>Les parents ont accès à tous les abonnements du compte.</p>` +
  `<p>Le mot de passe famille doit comporter 8 caractères et posséder aux moins 1 majuscule et 1 chiffre.</p>`,
  subscriberNumber: `<p><strong>Comment retrouver mon numéro d’abonné ?</strong></p>` +
  `<p>Si votre enfant est abonné au journal papier en plus du site, il trouvera son numéro d'abonné (sans la lettre)` +
  `sur le plastique recouvrant son journal, au-dessus de son adresse.</p>` +
  `<p><img alt="" src="https://api.playbacpresse.fr/uploads/media/page/2017/08/1747eac27f27405709100ff0974187d885a2c746.jpeg"></p>` +
  `<p>Si l'abonnement a été pris sur Internet, il suffit de cliquer sur le lien d'inscription fourni dans l’e-mail “mode d'emploi” ` +
  `reçu lors de la validation de la commande. Le numéro d'abonné est alors renseigné automatiquement.</p>` +
  `<p>Si vous souhaitez utiliser un code promo, ce champ n’est pas à compléter.</p>`,
  contestEmail: `Email servant uniquement au concours, il ne vous sera pas adressé d'offres commerciales. C'est à cette ` +
  `adresse que vous serez contacté en cas de gain.`,
  promoCode: `Entrez le code promo qui vous a été envoyé par mail par PlayBac.`
};
